import { useSelector } from 'react-redux';
import { SubmissionSectionSummaryV2 } from '@module/form-components';
import { useCallback } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
export var SectionSummaryContainer = function SectionSummaryContainer(_ref) {
  var _page$questions, _page$isLoadingQuesti, _page$selectedSection, _page$sectionSummarie;

  var onCancelPin = _ref.onCancelPin,
      readonly = _ref.readonly,
      labels = _ref.labels,
      updateSelectedSection = _ref.updateSelectedSection;
  // Selectors
  var page = useSelector(function (state) {
    return state.formPreviewApp;
  });
  var questions = (_page$questions = page === null || page === void 0 ? void 0 : page.questions) !== null && _page$questions !== void 0 ? _page$questions : [];
  var isLoadingQuestions = (_page$isLoadingQuesti = page === null || page === void 0 ? void 0 : page.isLoadingQuestions) !== null && _page$isLoadingQuesti !== void 0 ? _page$isLoadingQuesti : false;
  var selectedSectionIndex = (_page$selectedSection = page === null || page === void 0 ? void 0 : page.selectedSectionIndex) !== null && _page$selectedSection !== void 0 ? _page$selectedSection : 0;
  var sectionSummaries = (_page$sectionSummarie = page === null || page === void 0 ? void 0 : page.sectionSummaries) !== null && _page$sectionSummarie !== void 0 ? _page$sectionSummarie : [];
  var selectedSection = page === null || page === void 0 ? void 0 : page.selectedSection;
  var onSelectQuestion = useCallback(function (sectionIndex, questionId, sectionId) {
    if (!questionId) return;
    var question = questions === null || questions === void 0 ? void 0 : questions.find(function (q) {
      return q.id.toString() === questionId;
    });

    if ((question === null || question === void 0 ? void 0 : question.sectionId) !== (selectedSection === null || selectedSection === void 0 ? void 0 : selectedSection.id.toString())) {
      updateSelectedSection(sectionSummaries === null || sectionSummaries === void 0 ? void 0 : sectionSummaries.find(function (s) {
        return s.id.toString() === question.sectionId.toString();
      }));
    } else {
      var questionPreviewElement = document.getElementById("form-".concat(questionId));

      if (questionPreviewElement) {
        var isInModal = questionPreviewElement.closest('.ant-modal-body, .ant-drawer-body, [role="dialog"]');

        if (isInModal) {
          var scrollableContainer = questionPreviewElement.parentElement;

          while (scrollableContainer && scrollableContainer !== document.body) {
            var computedStyle = window.getComputedStyle(scrollableContainer);
            var overflowY = computedStyle.overflowY;
            var overflowX = computedStyle.overflowX;

            if ((overflowY === 'auto' || overflowY === 'scroll' || overflowX === 'auto' || overflowX === 'scroll') && scrollableContainer.scrollHeight > scrollableContainer.clientHeight) {
              break;
            }

            scrollableContainer = scrollableContainer.parentElement;
          }

          if (scrollableContainer && scrollableContainer !== document.body) {
            var containerRect = scrollableContainer.getBoundingClientRect();
            var elementRect = questionPreviewElement.getBoundingClientRect();
            var headerOffset = 80;
            var targetScrollTop = scrollableContainer.scrollTop + (elementRect.top - containerRect.top) - headerOffset;
            scrollableContainer.scrollTop = Math.max(0, targetScrollTop);
          } else {
            questionPreviewElement.scrollIntoView({
              behavior: 'smooth',
              block: 'start'
            });
          }
        } else {
          questionPreviewElement.scrollIntoView({
            behavior: 'smooth',
            block: 'start'
          });
        }
      }
    }
  }, [questions, selectedSection, sectionSummaries, updateSelectedSection]);
  return /*#__PURE__*/_jsx(SubmissionSectionSummaryV2, {
    selectedSectionIndex: selectedSectionIndex,
    sectionSummaries: sectionSummaries,
    label: labels,
    readonly: readonly,
    questionReleases: questions,
    isLoadingGetQuestions: isLoadingQuestions,
    onSelectQuestion: onSelectQuestion
  });
};